// @flow

import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import { WebsiteDefaultPage as BaseWebsiteDefaultPage } from 'components/Page';
import { PageType } from 'Constants';
import { OriginationFees } from 'data/global/footer/legal/numbered';
import { useImages } from 'hooks';
import { flex, Layout, maxWidthContainer, topBottomMargin, Width } from 'styles';
import { MarketsHero, ResourcesSideBar } from 'components/Content';
import { ImageLoader } from 'components/Gui';

const METADATA = {
  title: 'Financial products to simplify finances, faster',
  description: `At Markets Direct, we’re transforming home equity by creating a fast, simple and transparent process to bring you closer to your financial goals. We'll show you how to use home equity to consolidate debt, pay for home improvement or fund your retirement. It's quick and easy. Let’s unlock the potential of your largest asset.`,
};

const PAGE_TYPE = {
  product: PageType.PRODUCT.NONE,
};

const WebsiteDefaultPage = styled(BaseWebsiteDefaultPage)`
  width: 100% !important;
`;

const Wrapper = styled.div`
  width: 100%;
  ${flex()};
  flex-direction: column;
  ${topBottomMargin([Layout.NAV_HEIGHT_MOBILE, 0], [Layout.NAV_HEIGHT_DESKTOP, 0], [Layout.NAV_HEIGHT_DESKTOP, 0])};
`;

const Content = styled.div`
  width: 100%;
  background: white;

  > div {
    padding: 40px 0;
    ${maxWidthContainer(1080)};
    ${flex()};
    flex-direction: column;

    @media (min-width: ${Width.BREAK_MD}px) {
      ${flex('flex-start', 'flex-start')};
      flex-direction: row;
    }
  }
`;

const Data = [
  <>
    <strong>CONSOB | Italy</strong>
    {`

The supervisory authority for the Italian financial products market; its aims are to protect investors and the efficiency, transparency and development of the market.
`}
  </>,
  <>
    <strong>CNMV | Spain</strong>
    {`

The Comisión Nacional del Mercado de Valores (CNMV) is the agency in charge of supervising and inspecting the Spanish Stock Markets and the activities of all the participants in those markets. It was created by the Securities Market Law, which instituted in-depth reforms of this segment of the Spanish financial system.
`}
  </>,
  <>
    <strong>KNF | Poland</strong>
    {`

The Komisja Nadzoru Finansowego exercises supervision of the financial market, including banking supervision, supervision of the capital market, supervision of the insurance market, supervision of the pension market, supplementary supervision of financial conglomerates, supervision of electronic money institutions, payment institutions and payment service bureaus, as well as supervision of cooperative savings and credit unions.
`}
  </>,
];

const Text = styled.div`
  white-space: pre-line;
`;

const Country = styled.div`
  ${flex('flex-start', 'flex-start')};
  margin-top: 30px;
  > div {
    &:first-of-type {
      width: 150px;
      flex: 0 0 auto;
      margin-right: 40px;
    }
  }Triton Capital Markets Limited
`;

const PageContainer = ({ data }: { data: any }) => {
  const getImage = useImages(data);

  return (
    <WebsiteDefaultPage
      page={PAGE_TYPE}
      metaData={{
        ...METADATA,
      }}
      footerLegal={{
        numbered: OriginationFees,
      }}>
      <Wrapper>
        <MarketsHero
          title="RESOURCES"
          blurb="Hello? How can we help you?"
          image={{
            name: 'resources',
          }}
          images={data}
        />
        <Content>
          <div>
            <ResourcesSideBar sectionIndex={0} pageIndex={1}>
              <Text>
                <strong>Investor Compensation Scheme</strong>
                {`
                
The Investor Compensation Scheme administed by the Malta Financial Services Authority (MFSA), the Maltese regulator, provides limited protection for certain classes of investors. Triton Capital Markets Limited Contributes to this scheme annually and in the event it becomes insolvent, its customer are afforded protection. Triton Capital Markets Limited’s customers will be eligible for compensation of 90% of their investment up to a maximum limit of €20,000. Professional Clients or Eligibale counter parties are not eligible for compensation as they fall out of the scope of the Investor Compensation Scheme which was set up as a protection for retail customers.

`}
                <strong>Negative Balance Protection</strong>
                {`

Triton Capital Markets Ltd., provides clients with the benefit of Negative Balance Protection at its own cost which means that any client trading losses cannot exceed the available funds in the client accounts and client account balances will never become negative.`}
                {Data.map((text, index) => (
                  <Country key={`Data-${index}`}>
                    <div>
                      <ImageLoader image={getImage(index + 1)} />
                    </div>
                    <div>{text}</div>
                  </Country>
                ))}
              </Text>
            </ResourcesSideBar>
          </div>
        </Content>
      </Wrapper>
    </WebsiteDefaultPage>
  );
};

export default PageContainer;

export const query = graphql`
  query {
    imageToWebP: allFile(
      filter: {
        relativeDirectory: { in: ["pages/regulation-and-safety-of-funds", "pages/resources"] }
        extension: { nin: ["svg", "gif"] }
      }
    ) {
      edges {
        node {
          ...ImageToWebP
        }
      }
    }
    otherImage: allFile(
      filter: { relativeDirectory: { eq: "pages/regulation-and-safety-of-funds" }, extension: { in: ["svg", "gif"] } }
    ) {
      edges {
        node {
          ...OtherImage
        }
      }
    }
  }
`;
